import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PastTranscript from "../../components/PastTranscript/PastTranscript";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BiPlus, BiRefresh } from "react-icons/bi";
import { theme } from "../../utils/theme";
import { toast } from "react-toastify";
import ExceededPopup from "../../components/Popups/ExceededPopup";
import { fetchMeetings } from "../../services/MeetingService"
import PaginationBar from "../../components/Pagination/PaginationBar";
import Loader from "./../../components/Popups/Loader";

const Uploads = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { uploads } = useSelector((state) => state.uploadsReducer);
  const { userData } = useSelector((state) => state.authReducer);
  const [tab, setTab] = useState(2);
  const [modifiedUploads, setModifiedUploads] = useState();
  const dispatch = useDispatch();
  const [refreshActive, setRefreshActive] = useState(true);
  const [exceededModal, setExceededModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExceededHours, setIsExceededHours] = useState(false);
  const [totalMeetTime, setTotalMeetTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const fetchPastTranscripts = async () => {
    let arr = [];
    uploads &&
      uploads?.forEach((upload) => {
        let participant;
        try {
          participant = Object.entries(upload.participants)[0][0];
        } catch (err) {}
        // if (participant)
          arr.push({
            ...upload,
            tasks: upload.participants[participant]?.tasks.map((item) => {
              if (item?.name) return item;
              else
                return {
                  name: item?.name ? item.name : item,
                  completed: item?.completed ? item.completed : false,
                  transName: item?.transName ? item.transName : "",
                };
            }),
            tasksForOthers: upload.participants[participant]?.tasksForOthers.map(
              (item) => {
                if (item?.name) return item;
                else
                  return {
                    name: item?.name ? item.name : item,
                    completed: item?.completed ? item.completed : false,
                    transName: item?.transName ? item.transName : "",
                  };
              }
            ),
            participant: participant,
          });
      });
      console.log("ARRAY SIZE:", arr.length)
    setModifiedUploads(arr);
  };
  const [openedTranscript, setOpenedTranscript] = useState();

  useEffect(() => {
    fetchPastTranscripts();
  }, [uploads]);

  // useEffect(() => {
  //   if (searchParams.has("past")) {
  //     setTab(2);
  //   }
  // }, [searchParams]);

  const checkIfExceededRecordTime = async () => {
    const subscriptionData = userData?.subscription || {};
    const uploadRecordData = userData?.uploadRecord;
    const additionalParameter = Object.keys(subscriptionData || {})[0];
    const subscriptionName = Object.keys(subscriptionData)[0];
    console.log("subscriptionName: ", subscriptionName);
    console.log(
      "End period: ", subscriptionData?.[additionalParameter]?.periodEnd
    );
    const currentDate = Math.floor(new Date().getTime() / 1000);
    const endDate = subscriptionData?.[additionalParameter]?.periodEnd;
    console.log("currentDate: ", currentDate);
    if (
      subscriptionName === "free" ||
      ((subscriptionName === "productivity pro" ||
        subscriptionName === "business") &&
        endDate >= currentDate)
    ) {
      const limitFromCollection = subscriptionData?.[additionalParameter]?.recordLimit;
      // console.log("limitFromCollection: ", limitFromCollection);
      if (limitFromCollection === -1) {
        setIsExceededHours(false);
      } else if (limitFromCollection < uploadRecordData) {
        setIsExceededHours(true);
      }
    } else {
      setIsExceededHours(true);
    }
  };

  const fetchPaginationMeetings = async() => {
    setIsLoading(true);
    const data = await fetchMeetings(dispatch, page, limit);
    setIsLoading(false);
    const { records, count, totalPages } = data;
    setCount(count);
  }

  useEffect(() => {
    checkIfExceededRecordTime();
  }, []);

  useEffect(() => {
    fetchPaginationMeetings();
    console.log(`PAGE LIMIT:: ${page} ${limit}`)
  }, [page, limit])

  return (
    <div>
      <Loader isLoading={isLoading} />
      <div className="3xl:text-3xl text-2xl mb-[20px] font-medium flex items-center gap-[10px]">
        Uploads
        <BiRefresh
          title="Refresh Uploads"
          onClick={() => {
            if (refreshActive) {
              setRefreshActive(false);
              fetchPaginationMeetings().then((res) => {
                toast.success("Uploads updated");
                setRefreshActive(true);
              });
            }
          }}
          className={`cursor-pointer text-gray-800 ${
            !refreshActive && "rotateIndefinitely"
          }`}
        />
      </div>
      <div className="flex gap-[20px] w-fit justify-between items-center mb-[15px]">
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(2);
          }}
          style={{ color: tab === 2 ? "#07457f" : "#384853" }}
        >
          <div>Audios</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 2 ? "1.2px" : "0px" }}
          ></div>
        </div>
        {/* <div
          className="cursor-pointer"
          onClick={() => {
            setTab(3);
          }}
          style={{ color: tab === 3 ? "#07457f" : "#384853" }}
        >
          <div>Transcripts</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 3 ? "1.2px" : "0px" }}
          ></div>
        </div> */}
      </div>
      { (count > 0) && (
        <>
        <PaginationBar config={{
            count: count,
            page: page,
            setPage: setPage,
            limit: limit,
            setLimit: setLimit
          }} />
        </>
      ) }
      {/* // past audio transcripts */}
      {tab === 2 && (
        <>
          <div
            style={{ color: theme.color }}
            onClick={() => {
              if (!isExceededHours) {
                navigate("/upload");
              } else {
                setExceededModal(true);
              }
            }}
            className="flex items-center gap-[5px] my-[10px] font-semibold cursor-pointer"
          >
            <BiPlus /> Upload New
          </div>
          {modifiedUploads && modifiedUploads.length > 0 ? (
            modifiedUploads.map((pastTranscriptData, idx) => {
              if (
                !!pastTranscriptData?.fileDetails?.type.includes("audio") ||
                !!pastTranscriptData?.fileDetails?.type.includes("video")
              )
                return (
                  <PastTranscript
                    updateLocally={() => {
                      fetchPastTranscripts();
                    }}
                    data={pastTranscriptData}
                    key={pastTranscriptData?.id}
                    idx={idx}
                    setOpenedTranscript={setOpenedTranscript}
                    openedTranscript={openedTranscript}
                    page={page}
                    setPage={setPage}
                    fetchPaginationMeetings={fetchPaginationMeetings}
                  />
                );
              else return "";
            })
          ) : (
            <div className="text-gray-500">No Past Transcripts</div>
          )}
        </>
      )}
      {exceededModal && (
        <ExceededPopup
          onClose={() => {
            setExceededModal(false);
          }}
        />
      )}
    </div>
  );
};

export default Uploads;
